<template>
    <div>
        <div class="g-mt-8 g-mb-6" style="text-align:center">
            <img :src="image" width="160px" />
        </div>

        <g-row class="g-mb-7" type="flex" align="middle" justify="space-around" >
            <g-column :span="24" class="g-mb-5">
                <g-typography tag="h2" font-weight="semibold" size="h1" text-align="center" marginClass="mb-20" :value="title" />
            </g-column>

            <g-column :span="18">
                <g-typography tag="p" size="p" text-align="center" color="grey-6" :value="subtitle" />
            </g-column>
        </g-row>

        <g-row type="flex" align="middle" justify="space-around" class="g-mb-4">
            <g-column :span="10">
                <g-button
                    shape="round"
                    theme="live"
                    type="primary"
                    block
                    size="large"
                    @click="$emit('close')">
                    {{ buttonText }}
                </g-button>
            </g-column>
        </g-row>
    </div>
</template>

<script>
    import { PLACEHOLDER_IMAGE } from '../../../../../app-v2/constants/cdn-assets';

    export default {
        name: "Confirmation",

        props: {
            image: {
                type: String,
                default: PLACEHOLDER_IMAGE
            },
            title: {
                type: String,
                default: 'Account Linked'
            },
            subtitle: {
                type: String,
                default: 'The account has been successfully verified and linked to GRIN.'
            },
            buttonText: {
                type: String,
                default: 'Done'
            },
        },
    };
</script>
